var map = {
	"./violin1.jpg": [
		3918,
		918
	],
	"./violin2.jpg": [
		3513,
		513
	],
	"./violin3.jpg": [
		8252,
		252
	],
	"./violin4.jpg": [
		8215,
		215
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1872;
module.exports = webpackAsyncContext;